export const JOB_APPLICATION_FORM_ID = '#job-application-form';
export const DEFAULT_HR_EMAIL = 'hr@decodo.com';
export const PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[(-\s\.)?(0-9)]{6,20}$/;
export const VALID_PHONE_CHAR_REGEX = /^[\d()+-]+$/;
export const URL_REGEX =
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
export const INFO_MAX_LENGTH = 500;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const MB = 1024 ** 2;
export const MAX_RESUME_FILE_SIZE = 5 * MB;

export const SUPPORTED_FILE_TYPES = ['.pdf', '.doc', '.docx', '.png'];
